import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Suspense, useState } from 'react';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { IconButton } from '@mui/material';
import CascadingMenuHelpDialog from "./CascadingMenuHelpDialog.js";
export default function CascadingMenuHelpIconButton({ helpText, label, }) {
    const [helpDialogOpen, setHelpDialogOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { size: "small", onClick: event => {
                    event.stopPropagation();
                    setHelpDialogOpen(true);
                }, style: { marginLeft: 4, padding: 4 }, children: _jsx(HelpOutline, { fontSize: "small" }) }), helpDialogOpen ? (_jsxs(Suspense, { fallback: null, children: [_jsx(CascadingMenuHelpDialog, { helpText: helpText, label: label, onClose: event => {
                            event.stopPropagation();
                            setHelpDialogOpen(false);
                        } }), ' '] })) : null] }));
}
